import { useContext, useState } from "react";
import { Box, Drawer, useTheme } from "@mui/material";

import { AnimatedLogo } from "@aclymatepackages/atoms";

import SurveyHeader from "./SurveyHeader";
import SurveyError from "./SurveyError";
import { SurveyContext } from "./SurveyContext";

const SurveyLayout = ({
  surveyLoading,
  form,
  scoutPanel,
  summaryPane,
  mobileSummaryPaneBuilder,
  percentCompleted,
  sections,
  activeSectionId,
  error,
  backHref,
  backLabel
}) => {
  const { palette } = useTheme();
  const surveyContext = useContext(SurveyContext);
  const isScoutCollapsed = surveyContext?.isScoutCollapsed;

  const showFormColumn = surveyLoading || error || isScoutCollapsed;
  const showSummaryColumn = !showFormColumn && !!summaryPane;
  const [mobileSummaryOpen, setMobileSummaryOpen] = useState(false);

  return (
    <Box
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.backgroundGray.light
      }}
    >
      <SurveyHeader
        percentCompleted={percentCompleted || 0}
        sections={sections}
        activeSectionId={activeSectionId}
        onOpenSummary={summaryPane ? () => setMobileSummaryOpen(true) : null}
        backHref={backHref}
        backLabel={backLabel}
      />
      <Box
        flexGrow={1}
        display="flex"
        sx={{ flexDirection: { xs: "column", md: "row" } }}
        style={{ minHeight: 0 }}
      >
        {!surveyLoading && !error && scoutPanel}
        {showSummaryColumn && summaryPane}
        <Box
          p={{ xs: 3, md: 6 }}
          sx={{
            flex: "1 1 auto",
            boxSizing: "border-box",
            overflowY: "auto",
            display: showFormColumn ? { xs: "none", md: "flex" } : "none"
          }}
          flexDirection="column"
        >
          {surveyLoading && (
            <Box
              style={{ height: "100%" }}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <AnimatedLogo />
            </Box>
          )}
          {!surveyLoading && error && <SurveyError {...error} />}
          {!surveyLoading && !error && form}
        </Box>
      </Box>
      {summaryPane && (
        <Drawer
          variant="temporary"
          anchor="right"
          open={mobileSummaryOpen}
          onClose={() => setMobileSummaryOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": { width: "100%", boxSizing: "border-box" }
          }}
        >
          {mobileSummaryPaneBuilder
            ? mobileSummaryPaneBuilder({
                onCloseMobile: () => setMobileSummaryOpen(false)
              })
            : summaryPane}
        </Drawer>
      )}
    </Box>
  );
};

export default SurveyLayout;
